import React, { useState } from 'react';
import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  Avatar,
  Chip,
  useTheme,
  useMediaQuery,
 
  Button
} from '@mui/material';
import {
  Logout as LogoutIcon,
  AdminPanelSettings as AdminIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  PersonAdd as PersonAddIcon,  // ADD THIS LINE
  Sync as SyncIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  School as SchoolIcon, // <--- ADD THIS ICON
  Menu as MenuIcon,
  MoreVert as MoreVertIcon,
  CreditCard as CreditCardIcon, // Icon for card requests
  Groups as GroupsIcon,
  Event as EventIcon,
  Schedule as ScheduleIcon,
  Home as HomeIcon,
  Email as EmailIcon,
  Feedback as FeedbackIcon,
  Badge as BadgeIcon,
} from '@mui/icons-material';
import { useAdmin } from '../../contexts/AdminContext';
import { useNavigate } from 'react-router-dom';
import ModuleManagement from './ModuleManagement';
import StudentCardRequests from './StudentCardRequests';
import EmployeeManagement from './EmployeeManagement';
import GroupManagement from './GroupManagement';
import ExamPlanning from './ExamPlanning'; // <--- ADD THIS IMPORT
import ProfessorManagement from './ProfessorManagement';
// Import admin page components (we'll create these next)
import AdminOverview from './AdminOverview';
import StudentManagement from './StudentManagement';
import SyncManagement from './SyncManagement';
import SystemHealth from './SystemHealth';
import StudentRegistrations from './StudentRegistrations';
import LaureatManagement from './LaureatManagement'; // <--- ADD THIS IMPORT
import AdminSecurity from './AdminSecurity';
import AdminManagement from './AdminManagement';
import SecurityIcon from '@mui/icons-material/Security';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CoursePlanning from './CoursePlanning';
import StatisticsPage from './StatisticsPage';
import PedagogyStructure from './PedagogyStructure';
import NotificationsManagement from './NotificationsManagement';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import NotificationsIcon from '@mui/icons-material/Notifications';
import TuneIcon from '@mui/icons-material/Tune';
import AdminSettings from './AdminSettings';
import FolderIcon from '@mui/icons-material/Folder';
import AdminDocuments from './AdminDocuments';
import MasterformSubmissions from './MasterformSubmissions';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import InstitutionalEmails from './InstitutionalEmails';
import HistoryIcon from '@mui/icons-material/History';
import AdminAuthLogs from './AdminAuthLogs';
import GradeReclamations from './GradeReclamations';
import ExamStats from './ExamStats';
const DRAWER_WIDTH = 280;

const AdminDashboard = () => {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const [currentPage, setCurrentPage] = useState('overview');
  const [mobileMenu, setMobileMenu] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (isMobile) {
      setDrawerOpen(false);
    }
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMenu(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenu(null);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const isSuperAdmin = admin?.role === 'SUPER_ADMIN';
  const hasPermission = (pageId) => isSuperAdmin || (admin?.permissions || []).includes(pageId);

  const allNavigationItems = [
    {
      id: 'overview',
      label: 'Dashboard Overview',
      icon: <DashboardIcon />,
      color: '#3498db'
    },
      {
    id: 'registrations',  // NEW ITEM
    label: 'Student Registrations',
    icon: <PersonAddIcon />,
    color: '#27ae60'
  },
    {
      id: 'students',
      label: 'Student Management',
      icon: <PeopleIcon />,
      color: '#2ecc71'
    },
      {
    id: 'modules',  // ← ADD THIS
    label: 'Module Management',
    icon: <SettingsIcon />,
    color: '#f39c12'
  },
  {
    id: 'pedagogy-structure',
    label: 'Structure Pédagogique',
    icon: <AccountTreeIcon />,
    color: '#16a085'
  },
  {
    id: 'course-schedules', // New ID for navigation
    label: 'course program ', // Arabic Label
    icon: <ScheduleIcon />,
    color: '#2980b9' // Choose a distinct color
  },
  {
    id: 'professors',
    label: 'Professeurs',
    icon: <BadgeIcon />,
    color: '#16a085'
  },
  {                                 // <--- START OF NEW ITEM
      id: 'exams',
      label: 'Planning Examens',
      icon: <EventIcon />,
      color: '#9b59b6' 
    },
  {
      id: 'laureats',
      label: 'Gestion des Lauréats',
      icon: <SchoolIcon />,
      color: '#8e44ad'
    },
     {
      id: 'security',
      label: 'change password',
      icon: <SchoolIcon />,
      color: '#8e44ad'
    },
    {
      id: 'hr', // ID for HR
      label: 'Ressources Humaines',
      icon: <PeopleIcon />, // You can reuse PeopleIcon or import BadgeIcon
      color: '#ff9800' // Orange color
    },
    {
    id: 'groups', // New ID
    label: 'Gestion des Groupes',
    icon: <GroupsIcon />,
    color: '#009688' // Teal color
  },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: <NotificationsIcon />,
      color: '#e67e22'
    },
    {
      id: 'statistics',
      label: 'Statistiques',
      icon: <AssessmentIcon />,
      color: '#8e44ad'
    },
    {
      id: 'sync',
      label: 'Data Synchronization',
      icon: <SyncIcon />,
      color: '#e74c3c'
    },
      {
    id: 'card-requests',
    label: 'Student Card Requests',
    icon: <CreditCardIcon />,
    color: '#1abc9c'
  },
    {
      id: 'grade-reclamations',
      label: 'Réclamations Notes',
      icon: <FeedbackIcon />,
      color: '#d35400'
    },
    {
      id: 'masterform',
      label: 'Demandes Master',
      icon: <HistoryEduIcon />,
      color: '#2c3e50'
    },
    {
      id: 'exam-stats',
      label: 'Statistiques Examens',
      icon: <AssessmentIcon />,
      color: '#1565c0'
    },
    {
      id: 'system',
      label: 'System Health',
      icon: <AssessmentIcon />,
      color: '#9b59b6'
    },
    {
      id: 'admin-management',
      label: 'Admin Management',
      icon: <ManageAccountsIcon />,
      color: '#c0392b',
      superAdminOnly: true
    },
    {
      id: 'documents',
      label: 'Documents',
      icon: <FolderIcon />,
      color: '#7c3aed',
    },
    {
      id: 'institutional-emails',
      label: 'Emails Institutionnels',
      icon: <EmailIcon />,
      color: '#0891b2',
    },
    {
      id: 'auth-logs',
      label: 'Journal de Connexion',
      icon: <HistoryIcon />,
      color: '#0f766e',
    },
    {
      id: 'app-settings',
      label: 'Paramètres',
      icon: <TuneIcon />,
      color: '#16a085',
      superAdminOnly: true
    }
  ];

  // Security page is always available; other pages filtered by permission
  const navigationItems = allNavigationItems.filter(item => {
    if (item.superAdminOnly) return isSuperAdmin;
    if (item.id === 'security') return true;
    return hasPermission(item.id);
  });

  const renderPageContent = () => {
    switch (currentPage) {
      case 'overview':
        return <AdminOverview onNavigate={handlePageChange} />;
           case 'registrations':  // NEW CASE
      return <StudentRegistrations />;
      case 'students':
        return <StudentManagement />;
            case 'modules':  // ← ADD THIS CASE
      return <ModuleManagement />;
      case 'pedagogy-structure':
        return <PedagogyStructure />;
      case 'hr':
    return <EmployeeManagement />;
      case 'notifications':
        return <NotificationsManagement />;
      case 'statistics':
        return <StatisticsPage />;
      case 'sync':
        return <SyncManagement />;
        case 'exams':               
        return <ExamPlanning />;
      case 'system':
        return <SystemHealth />;
        case 'laureats':                
        return <LaureatManagement />;
      case 'card-requests':
        return <StudentCardRequests />;
      case 'grade-reclamations':
        return <GradeReclamations />;
      case 'masterform':
        return <MasterformSubmissions />;
      case 'exam-stats':
        return <ExamStats />;
        case 'course-schedules': // Add this case
      return <CoursePlanning />;
        case 'professors':
      return <ProfessorManagement />;
        case 'groups':
      return <GroupManagement />;
      case 'security':
        return <AdminSecurity />;
      case 'admin-management':
        return <AdminManagement currentAdminUsername={admin?.username} />;
      case 'documents':
        return <AdminDocuments />;
      case 'institutional-emails':
        return <InstitutionalEmails />;
      case 'auth-logs':
        return <AdminAuthLogs />;
      case 'app-settings':
        return <AdminSettings />;
      default:
        return <AdminOverview onNavigate={handlePageChange} />;
    }
  };

  const drawer = (
    <Box sx={{ height: '100%', bgcolor: '#f8f9fa' }}>
      {/* Drawer Header */}
      <Box 
        sx={{ 
          p: 3, 
          background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <AdminIcon sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h6" fontWeight="600">
          Admin Portal
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          System Management
        </Typography>
      </Box>

      {/* Admin Info */}
      {admin && (
        <Box sx={{ p: 3, textAlign: 'center', bgcolor: 'white', mx: 2, mt: 2, borderRadius: 3 }}>
          <Avatar
            sx={{
              width: 60,
              height: 60,
              mx: 'auto',
              mb: 2,
              background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
              fontSize: '1.5rem',
              fontWeight: 'bold'
            }}
          >
            {admin.username?.charAt(0).toUpperCase() || 'A'}
          </Avatar>
          <Typography variant="h6" fontWeight="600" gutterBottom>
            {admin.username}
          </Typography>
          <Chip
            label={
              admin?.role === 'SUPER_ADMIN'    ? 'Super Admin' :
              admin?.role === 'RH_MANAGER'     ? 'RH Manager' :
              admin?.role === 'SCOLARITE'      ? 'Scolarité' :
              admin?.role === 'STATISTIQUES'   ? 'Statistiques' :
              admin?.role === 'READONLY'       ? 'Read Only' :
              admin?.role || 'Admin'
            }
            color={admin?.role === 'SUPER_ADMIN' ? 'error' : 'primary'}
            size="small"
            sx={{ fontWeight: 600 }}
          />
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
            Logged in: {new Date(admin.loginTime).toLocaleTimeString()}
          </Typography>
        </Box>
      )}

      {/* Navigation */}
      <Box sx={{ mt: 2 }}>
        <List sx={{ px: 2 }}>
          {navigationItems.map((item) => (
            <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
              <ListItemButton
                onClick={() => handlePageChange(item.id)}
                selected={currentPage === item.id}
                sx={{
                  borderRadius: 3,
                  '&.Mui-selected': {
                    background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}CC 100%)`,
                    color: 'white',
                    '&:hover': {
                      background: `linear-gradient(135deg, ${item.color}CC 0%, ${item.color} 100%)`,
                    }
                  },
                  '&:hover': {
                    background: `${item.color}15`,
                  }
                }}
              >
                <ListItemIcon 
                  sx={{ 
                    color: currentPage === item.id ? 'white' : item.color,
                    minWidth: 40 
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: currentPage === item.id ? 600 : 500,
                    fontSize: '0.9rem'
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Footer */}
      <Box sx={{ mt: 'auto', p: 2 }}>
        <Divider sx={{ mb: 2 }} />
        <Button
          fullWidth
          variant="outlined"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          sx={{ mb: 1, borderRadius: 3 }}
        >
          Student Portal
        </Button>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{ borderRadius: 3 }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Top AppBar */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)'
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={toggleDrawer}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          <AdminIcon sx={{ mr: 2, display: { xs: 'none', md: 'block' } }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Student Information System - Admin
          </Typography>

          {/* Desktop admin info */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
            {admin && (
              <>
                <Typography variant="body2">
                  Welcome, {admin.username}
                </Typography>
                <IconButton
                  color="inherit"
                  onClick={handleMobileMenuOpen}
                >
                  <MoreVertIcon />
                </IconButton>
              </>
            )}
          </Box>

          {/* Mobile menu */}
          <Menu
            anchorEl={mobileMenu}
            open={Boolean(mobileMenu)}
            onClose={handleMobileMenuClose}
          >
            <MenuItem onClick={() => { navigate('/'); handleMobileMenuClose(); }}>
              <ListItemIcon><HomeIcon fontSize="small" /></ListItemIcon>
              Student Portal
            </MenuItem>
            <MenuItem onClick={() => { handleLogout(); handleMobileMenuClose(); }}>
              <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: DRAWER_WIDTH,
            boxSizing: 'border-box',
            border: 'none',
            boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          position: 'fixed',
          top: '64px',
          left: { xs: 0, md: `${DRAWER_WIDTH}px` },
          right: 0,
          bottom: 0,
          bgcolor: '#f5f5f5',
          overflow: 'auto'
        }}
      >
        <Box sx={{ p: 3, width: '100%', maxWidth: '1400px', mx: 'auto' }}>
          {renderPageContent()}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboard;